<template>
  <div>
    <!--기본정보-->
    <field-select-module v-model="form.stdInfo" :board="board" :is-print="isPrint" />

    <!-- 산업재해 발생정보-->
    <write-grid-container class="write-grid-component" title="산업재해 발생정보" v-model="form.subInfo" :options="gridContainerOptions">
      <template slot-scope="{ index, label, value, dataType }">
        <div v-if="isPrint" class="printing">
          <div class="print-input" v-if="dataType === 'date'">{{ form.subInfo[value] }}</div>
          <div class="print-input" v-else>{{ form.subInfo[value] }}</div>
        </div>

        <div v-else class="write-grid-container-col">
          <date-selector v-if="dataType === 'date'" class="w-full" v-model="form.subInfo[value]" />
          <template v-else-if="dataType === 'radio1' || dataType === 'radio2'">
            <div class="pt-2">
              <vs-radio v-for="option in result_options[dataType]" :key="`${dataType}${option}`" v-model="form.subInfo[value]" :vs-name="dataType" :vs-value="option" class="mx-2">
                {{ option }}
              </vs-radio>
            </div>
          </template>
          <div v-else-if="dataType === 'cal'" class="flex" style="align-items: center">
            <ml-input class="w-full" type="number" v-model="form.subInfo[value]" :readonly="true" />
            <span class="ml-2" style="font-weight: 500">일</span>
          </div>
          <div v-else-if="dataType === 'year'" class="flex" style="align-items: center">
            <ml-input class="w-full" type="number" v-model="form.subInfo[value]" :min-value="0" :max-value="100" />
            <span class="ml-2" style="font-weight: 500">년</span>
          </div>
          <disaster-class-selector v-else-if="dataType === 'disaster'" v-model="form.subInfo[value]" class="w-full" />
          <file-uploader v-else-if="dataType === 'file'" v-model="form.subInfo[value]" />
          <div v-else-if="dataType === 'radio_date'">
            <div class="radio-date-container">
              <div>
                <vs-radio v-for="option in result_options[dataType]" :key="`${dataType}${option}`" v-model="form.subInfo[value].승인여부" :vs-name="value" :vs-value="option" class="mx-2">
                  {{ option }}
                </vs-radio>
              </div>
              <date-selector class="w-full" v-model="form.subInfo[value].날짜" />
            </div>
          </div>
          <div v-else-if="dataType === 'select_input'">
            <vs-select class="w-full" v-model="form.subInfo[value].구분" autocomplete>
              <vs-select-item v-for="option in result_options[dataType]" :text="option" :value="option" />
            </vs-select>
            <div v-if="form.subInfo[value].구분" class="mt-2 flex items-center whitespace-no-wrap gap-2">
              <ml-input v-model="form.subInfo[value].value" class="w-full" />
              <span v-if="getUnit(form.subInfo[value].구분)">{{ getUnit(form.subInfo[value].구분) }}</span>
            </div>
          </div>
          <div v-else-if="dataType === 'blank'" class="blank" />
          <ml-input v-else class="w-full" v-model="form.subInfo[value]" :max="100" />
        </div>
      </template>
    </write-grid-container>

    <!--    파일첨부-->
    <file-upload-module class="mt-28px" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly" />

    <popup-load-prev-board title="산업재해 발생현황" v-model="showLoadPrevBoard" :set-board-id="823" @selectRowData="prevBoardSelectRow" />
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import WriteGridContainer from "@/components/WriteGridContainer.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import DateSelectorRang from "@/components/selector/DateSelectorRang.vue";
import CustomOptionSelector from "@/components/selector/CustomOptionSelector.vue";
import FileDownloadPost from "@/components/FileDownloadPost.vue";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector.vue";
import FileUploader from "@/components/FileUploader.vue";
import { required } from "vuelidate/lib/validators";
import PopupLoadPrevBoard from "@/popup/PopupLoadPrevBoard.vue";

export default {
  components: {
    PopupLoadPrevBoard,
    FileUploader,
    DisasterClassSelector,
    FileDownloadPost,
    CustomOptionSelector,
    DateSelectorRang,
    DateSelector,
    WriteGridContainer,
    FileUploadModule,
    FieldSelectModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
    header: Object,
  },
  validations: {
    form: {
      subInfo: {
        재해일시: { required },
        요양일수: {
          if(value) {
            // 복직일을 입력 안하면 통과
            if (this.form.subInfo["복직일"] === "") return true;

            // 복직일을 입력하면 요양일수를 계산
            this.warningInfo = !(value >= 0);
            return !this.warningInfo;
          },
        },
      },
    },
  },
  data() {
    return {
      showLoadPrevBoard: false,
      warningInfo: false,
      result_options: {
        radio1: ["재해자", "관리감독자", "기타"],
        radio2: ["승인", "진행중", "불승인"],
        radio_date: ["승인", "미승인"],
        select_input: ["견책", "근신", "감봉", "정직", "면직"],
      },
      gridContainerOptions: {
        dataTypes: ["radio1", "blank", "blank", "date", "string", "disaster", "date", "string", "blank", "radio_date", "radio_date", "blank", "select_input"],
        labels: ["구분", "", "", "재해일시", "팀명/업체명", "재해형태", "복직일", "이름", "", "안전보건 위원회", "노무 위원회", "", "징계결과"],
        values: ["구분", "", "", "재해일시", "팀명_업체명", "재해형태", "복직일", "이름", "", "안전보건위원회", "노무위원회", "", "징계결과"],
        classes: ["", "hidden xl:block", "hidden xl:block", "", "", "", "", "", "hidden xl:block", "", "", "hidden xl:block", ""],
      },

      form: {
        stdInfo: {},
        fileList: [],
        subInfo: {},
        connect823Id: null,
      },

      connect944Id: null,
      connect945Id: null,
    };
  },
  computed: {
    projectId() {
      return parseInt(this.$route.params.proj_id) || 0;
    },
    postId() {
      return parseInt(this.$route.params.postId);
    },
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
    "form.subInfo.재해일시": {
      immediate: true,
      deep: true,
      handler(value) {
        const 재해일시 = this.form.subInfo["재해일시"];
        const 복직일 = this.form.subInfo["복직일"];
        if (!재해일시 || 재해일시 === "" || !복직일 || 복직일 === "") {
          this.form.subInfo["요양일수"] = "";
          return;
        }
        if (this.$moment(재해일시).isAfter(복직일)) {
          this.form.subInfo["요양일수"] = -1;
          this.form.subInfo["복직일"] = "";
          return;
        }

        const result = this.$moment(복직일).diff(재해일시, "days");
        this.form.subInfo["요양일수"] = result;
      },
    },
    "form.subInfo.복직일": {
      immediate: true,
      deep: true,
      handler(value) {
        const 재해일시 = this.form.subInfo["재해일시"];
        const 복직일 = this.form.subInfo["복직일"];
        if (!재해일시 || 재해일시 === "" || !복직일 || 복직일 === "") {
          this.form.subInfo["요양일수"] = "";
          return;
        }
        if (this.$moment(재해일시).isAfter(복직일)) {
          this.form.subInfo["요양일수"] = "";
          this.form.subInfo["재해일시"] = "";
          return;
        }

        const result = this.$moment(복직일).diff(재해일시, "days");
        this.form.subInfo["요양일수"] = result;
      },
    },
  },
  async created() {
    this.$store.commit("board/SET_BOARD_CONNECT_823", null);

    // subInfo 초기화
    this.form.subInfo = this.gridContainerOptions.values.reduce((acc, cur) => {
      acc[cur] = "";
      return acc;
    }, {});
    this.form.subInfo.구분 = "직영";
    this.form.subInfo.안전보건위원회 = { 승인여부: "", 날짜: "" };
    this.form.subInfo.노무위원회 = { 승인여부: "", 날짜: "" };
    this.form.subInfo.징계결과 = { 구분: "", value: "" };

    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }

    // 연결된 944, 945 postId를 찾는다.
    if (this.postId) {
      const apiOptions = {
        projectId: this.projectId,
        page: 1,
        perPage: 1,
        orderTarget: "created_at",
        orderDirection: "desc",
        conditions: [{ key: "body.connect823Id", operator: "=", value: `${this.postId}` }],
      };

      // 944, 945 호출
      const [res944, res945] = await Promise.all([this.$store.dispatch("approval/LOAD_POST_ALL", { ...apiOptions, boardSlug: `board-944` }), this.$store.dispatch("approval/LOAD_POST_ALL", { ...apiOptions, boardSlug: `board-945` })]);

      const post944 = res944 && res944.data && res944.data.length > 0 ? res944.data[0] : null;
      const post945 = res945 && res945.data && res945.data.length > 0 ? res945.data[0] : null;

      if (post944) this.connect944Id = post944.post_id;
      if (post945) this.connect945Id = post945.post_id;
    }
  },
  methods: {
    validate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (!this.$v.form.subInfo.재해일시.required) return "재해일시를 반드시 입력해야 합니다";

        if (this.warningInfo) return "복직일은 재해일시 이후로 입력해야 합니다";
      }
    },
    /**
     * 개선전, 개선후 게시글 생성 페이지로 이동
     * 만약 작성된 페이지가 존재하면 작성된 페이지로 이동
     * 0: 개선전, 1: 개선후
     */
    movePage(type) {
      // 페이지 이동동
      switch (type) {
        case 0:
          if (this.connect944Id) {
            this.$router.push({
              name: "write|update|tab",
              params: {
                boardId: "944",
                boardSlug: "board-944",
                pageType: "write",
                proj_id: this.projectId,
                postId: this.connect944Id,
              },
            });
          } else {
            this.$store.commit("board/SET_BOARD_CONNECT_823", this.postId);
            this.$router.push({
              name: "write|tab",
              params: {
                boardId: "944",
                boardSlug: "board-944",
                pageType: "write",
                proj_id: this.projectId,
              },
            });
          }
          break;
        case 1:
          if (this.connect945Id) {
            this.$router.push({
              name: "write|update|tab",
              params: {
                boardId: "945",
                boardSlug: "board-945",
                pageType: "write",
                proj_id: this.projectId,
                postId: this.connect945Id,
              },
            });
          } else {
            this.$store.commit("board/SET_BOARD_CONNECT_823", this.postId);
            this.$router.push({
              name: "write|tab",
              params: {
                boardId: "945",
                boardSlug: "board-945",
                pageType: "write",
                proj_id: this.projectId,
              },
            });
          }
          break;
      }
    },
    getUnit(구분) {
      if (구분 === "견책") return "";
      if (구분 === "근신") return "일";
      if (구분 === "감봉") return "";
      if (구분 === "정직") return "개월";
      return "N/A";
    },
    setNormalBoardButtons(template) {
      const 이전문서불러오기 = {
        shouldShow: { mode: "c|u", freePass: 0, permission: "c|u", onlyWriter: true },
        component: "vs-button",
        props: { class: "col-span-2", color: "secondary", type: "border" },
        content: "산업재해 불러오기",
        emits: {
          click: (func) => {
            this.showLoadPrevBoard = true;
          },
        },
      };
      return [이전문서불러오기, template.print, template.delete, template.move, template.save];
    },
    prevBoardSelectRow(data) {
      let postContent = data.post_content;
      if (postContent) {
        postContent = JSON.parse(postContent);
        const year = postContent.header.year;
        const body = postContent.body;

        console.log("body", body);

        this.header.year = year;
        this.form.stdInfo.field_address = body.stdInfo.field_address;
        this.form.stdInfo.field_id = body.stdInfo.field_id;
        this.form.stdInfo.field_name = body.stdInfo.field_name;

        this.form.subInfo.재해일시 = body.subInfo.재해일시;
        this.form.subInfo.팀명_업체명 = body.subInfo.팀명_업체명;
        this.form.subInfo.재해형태 = body.subInfo.재해형태;
        this.form.subInfo.복직일 = body.subInfo.복직일;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.custom-btn {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.write-grid-component {
  ::v-deep(.writeGridContainer) {
    .item {
      align-items: start;
      & > div:first-child {
        padding: 8px 0;
      }
    }
    align-items: start;
  }
}
.radio-date-container {
  display: flex;
  align-items: center;
  flex-flow: row nowrap;
  white-space: nowrap;
  gap: 8px;
  padding-top: 0;
}

@media (max-width: 1536px) {
  .radio-date-container {
    padding-top: 8px;
    flex-flow: column nowrap;
    align-items: flex-start;
  }
}
@media (max-width: 1200px) {
  .radio-date-container {
    padding-top: 0;
    flex-flow: row nowrap;
    align-items: center;
  }
  .write-grid-component {
    ::v-deep(.writeGridContainer) {
      .item {
        align-items: start;
        & > div:first-child {
          padding: 0;
        }
      }
      align-items: start;
    }
  }
}
</style>
